
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[name]",
      function () {
        return require("private-next-pages/work/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[name]"])
      });
    }
  